import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Building2, Briefcase, CheckSquare, Users, Settings, LogOut, Shield, Eye, FileText, Wrench } from 'lucide-react';
import { useAuth } from '../utils/auth';
import { getPendingValidationsCount } from '../utils/mockData';
export function Sidebar() {
  const {
    user,
    logout
  } = useAuth();
  const pendingCount = getPendingValidationsCount();
  // Role-based navigation
  const getNavItems = () => {
    if (user?.role === 'technicien') {
      return [{
        icon: LayoutDashboard,
        label: 'Mes Chantiers',
        path: '/'
      }];
    }
    if (user?.role === 'chef_equipe') {
      return [{
        icon: LayoutDashboard,
        label: 'Mes Chantiers',
        path: '/'
      }, {
        icon: CheckSquare,
        label: 'Validations',
        path: '/validations',
        badge: pendingCount
      }];
    }
    if (user?.role === 'direction') {
      return [{
        icon: LayoutDashboard,
        label: 'Tableau de Bord',
        path: '/'
      }, {
        icon: Building2,
        label: 'Clients',
        path: '/clients'
      }, {
        icon: Briefcase,
        label: 'Chantiers',
        path: '/chantiers'
      }, {
        icon: Users,
        label: 'Équipe',
        path: '/team'
      }];
    }
    if (user?.role === 'bureau') {
      return [{
        icon: LayoutDashboard,
        label: 'Tableau de Bord',
        path: '/'
      }, {
        icon: Building2,
        label: 'Clients',
        path: '/clients'
      }, {
        icon: Briefcase,
        label: 'Chantiers',
        path: '/chantiers'
      }, {
        icon: CheckSquare,
        label: 'Validations',
        path: '/validations',
        badge: pendingCount
      }, {
        icon: Users,
        label: 'Équipe',
        path: '/team'
      }];
    }
    // Admin - full access
    return [{
      icon: LayoutDashboard,
      label: 'Tableau de Bord',
      path: '/'
    }, {
      icon: Building2,
      label: 'Clients',
      path: '/clients'
    }, {
      icon: Briefcase,
      label: 'Chantiers',
      path: '/chantiers'
    }, {
      icon: CheckSquare,
      label: 'Validations',
      path: '/validations',
      badge: pendingCount
    }, {
      icon: Users,
      label: 'Équipe',
      path: '/team'
    }];
  };
  const navItems = getNavItems();
  const getRoleBadge = () => {
    const badges = {
      admin: {
        icon: Shield,
        label: 'Administrateur',
        color: 'text-purple-300',
        iconColor: 'text-purple-400'
      },
      direction: {
        icon: Eye,
        label: 'Direction',
        color: 'text-blue-300',
        iconColor: 'text-blue-400'
      },
      bureau: {
        icon: FileText,
        label: 'Bureau',
        color: 'text-teal-300',
        iconColor: 'text-teal-400'
      },
      chef_equipe: {
        icon: Wrench,
        label: "Chef d'Équipe",
        color: 'text-amber-300',
        iconColor: 'text-amber-400'
      },
      technicien: {
        icon: Wrench,
        label: 'Technicien',
        color: 'text-green-300',
        iconColor: 'text-green-400'
      }
    };
    return badges[user?.role || 'technicien'];
  };
  const roleBadge = getRoleBadge();
  return <aside className="hidden md:flex flex-col w-64 bg-[#1E2A3A] text-white h-screen fixed left-0 top-0 z-50 shadow-strong" data-id="element-150">
      {/* Logo */}
      <div className="p-6 border-b border-white/10" data-id="element-151">
        <div className="flex flex-col items-center gap-3" data-id="element-152">
          <img src="https://cdn.magicpatterns.com/uploads/rMFF7VCa1dN6Z32dDkPmmj/Logo-anime-_(1).gif" alt="France Décoration" className="w-20 h-20 object-contain" data-id="element-153" />
          <div className="text-center" data-id="element-154">
            <h1 className="font-bold text-lg leading-none" data-id="element-155">
              FRANCE DÉCORATION
            </h1>
            <p className="text-xs text-gray-400 mt-1" data-id="element-156">Gestion de Chantiers</p>
          </div>
        </div>
      </div>

      {/* User Badge */}
      <div className="px-4 py-4 bg-white/5 border-b border-white/10" data-id="element-157">
        <div className="flex items-center gap-3" data-id="element-158">
          <img src={user?.avatar} alt={user?.name} className="w-9 h-9 rounded-full ring-2 ring-white/20" data-id="element-159" />
          <div className="flex-1 min-w-0" data-id="element-160">
            <p className="text-sm font-medium text-white truncate" data-id="element-161">
              {user?.name}
            </p>
            <div className="flex items-center gap-1.5 mt-0.5" data-id="element-162">
              <roleBadge.icon size={10} className={roleBadge.iconColor} data-id="element-163" />
              <span className={`text-xs ${roleBadge.color}`} data-id="element-164">
                {roleBadge.label}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-1 overflow-y-auto" data-id="element-165">
        {navItems.map(item => <NavLink key={item.path} to={item.path} className={({
        isActive
      }) => `flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 relative group ${isActive ? 'bg-[#1DBAB4] text-white shadow-md font-medium' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-166">
            <item.icon size={20} className="flex-shrink-0" data-id="element-167" />
            <span className="flex-1" data-id="element-168">{item.label}</span>
            {item.badge && item.badge > 0 && <span className="bg-[#E85D4A] text-white text-xs font-bold px-2 py-0.5 rounded-full min-w-[20px] text-center shadow-sm" data-id="element-169">
                {item.badge}
              </span>}
          </NavLink>)}
      </nav>

      {/* Footer */}
      <div className="p-4 border-t border-white/10 space-y-1" data-id="element-170">
        {user?.role === 'admin' && <NavLink to="/settings" className={({
        isActive
      }) => `flex items-center gap-3 px-4 py-3 w-full rounded-lg transition-all duration-200 ${isActive ? 'bg-white/10 text-white' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-171">
            <Settings size={20} data-id="element-172" />
            <span data-id="element-173">Paramètres</span>
          </NavLink>}
        <button onClick={logout} className="flex items-center gap-3 px-4 py-3 w-full text-red-400 hover:bg-red-500/10 rounded-lg transition-all duration-200" data-id="element-174">
          <LogOut size={20} data-id="element-175" />
          <span data-id="element-176">Déconnexion</span>
        </button>
      </div>
    </aside>;
}